<button
  type="button"
  class="score-tab"
  [class.active]="active()"
  [style.--score-color]="'var(' + colorVar() + ')'"
>
  <div class="score-tab-header">
    <span class="label">{{ label() }}</span>
    <span class="value" [class.suspended]="isRatingSuspended()"
      ><span class="value-number">{{ isRatingSuspended() ? '?' : value() }}</span
      ><span class="max-number">/{{ max() }}</span></span
    >
  </div>
  <div class="track">
    <div class="fill" [style.width.%]="fillPercent()"></div>
  </div>
</button>
